import script from "./LandingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingPage.vue?vue&type=script&setup=true&lang=ts"

import "./LandingPage.vue?vue&type=style&index=0&id=34737051&lang=scss"
import "./LandingPage.vue?vue&type=style&index=1&id=34737051&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34737051"]])

export default __exports__